import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Location } from '@angular/common';
import { ToastService } from '../../services/toast.service';
import { SpinnerService } from '../../services/spinner.service';
import * as ExcelJS from 'exceljs';
import { PlanoDeContasService } from '../../services/plano-de-contas.service';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum';
import { AuthService } from '../../services/auth.service';
import { JwtHelper } from '../../helpers/jwtDecode.helper';
import { MessageService } from 'primeng/api';
import { BalancoPatrimonial } from '../../models/balancoPatrimonial.model';
import { descricaoTipoTransacaoContabil, TipoTransacaoContabil } from '../../models/enums/tipoTransacaoContabil.enum';
import { FormataValorPositivo } from '../../helpers/formata-valor-positivo.helper';
import { Icones } from '../../shared/variaveisDeRotas';
import { retornaDescricao } from '../../shared/mock/descricao';


@Component({
  selector: 'app-balanco-patrimonial',
  templateUrl: './balanco-patrimonial.component.html',
  styleUrl: './balanco-patrimonial.component.scss'
})
export class BalancoPatrimonialComponent implements OnInit {

  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  @ViewChild('dt') dt: Table | undefined;

  contasBalancoPatrimonial: BalancoPatrimonial[] = [];
  loading: boolean = false;
  private userId: string;
  date: Date[] | undefined;
  anoAtual: number;
  anoAnterior: number;
  anoFormatado: Date;

  constructor(
    private planoDeContasService: PlanoDeContasService,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private location: Location,
    private authService: AuthService,
    private jwtHelper: JwtHelper,
    private messageService: MessageService,
    public formataValorPositivoHelper: FormataValorPositivo
  ) {
    const currentYear = new Date().getFullYear();
    this.anoAtual = currentYear;
    this.anoAnterior = currentYear - 1;
    this.userId = this.jwtHelper.getUserIdFromToken();
  }

  ngOnInit(): void {
    this.tituloChange.emit('Balanço Patrimonial');
    this.iconeChange.emit(Icones.listaTopicoAmarelo);
    this.tituloDescricao.emit(retornaDescricao('balancoPatrimonial').titulo);
    this.textoDescricao.emit(retornaDescricao('balancoPatrimonial').texto);
    this.mostrarDescricao.emit(true)

    if (!this.anoFormatado) {
      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      this.anoFormatado = currentDate;
      this.anoAnterior = currentYear - 1;
    }

    this.obterRelatorioBalancoPatrimonial();
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
  }

  onDateChange(): void {
    const selectedDate = Array.isArray(this.date) ? this.date[0] : this.date;

    if (selectedDate && !isNaN(selectedDate.getTime())) {
      const selectedYear = selectedDate.getFullYear();
      this.anoFormatado = selectedDate;
      this.anoAnterior = selectedYear - 1;
      this.anoAtual = selectedYear;

      this.clearToast();
      this.obterRelatorioBalancoPatrimonial();
    }
  }

  obterRelatorioBalancoPatrimonial(): void {
    if (!this.anoFormatado) {
      this.toastService.setMensagemToast('Período não selecionado.', SeveridadeToast.Error);
      return;
    }

    this.loading = true;
    this.spinnerService.show('Carregando Relatório BP...');
    this.planoDeContasService.listarRelatorioBalancoPatrimonial(
      this.anoFormatado,
      this.userId
    ).subscribe({
      next: (contas) => {
        this.contasBalancoPatrimonial = contas.map(conta => ({
          ...conta,
          descricaoTipoTransacaoAnoAtual: conta.naturezaSaldoAnoAtual === TipoTransacaoContabil.Debito ? 'Débito' : 'Crédito',
          descricaoTipoTransacaoAnoAnterior: conta.naturezaSaldoAnoAnterior === TipoTransacaoContabil.Debito ? 'Débito' : 'Crédito'
        }));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toastService.setMensagemToast('Erro ao carregar relatório de balanço patrimonial.', SeveridadeToast.Error);
      },
      complete: () => {
        this.spinnerService.hide();
      }
    });
  }

  clearToast(): void {
    this.messageService.clear();
  }

  applyFilterGlobal(value: string): void {
    if (this.dt) {
      this.dt.filterGlobal(value, 'contains');
    }
  }

  downloadExcel() {
    this.spinnerService.show('Gerando relatório Excel...');
    
    let dadosParaExportar = this.contasBalancoPatrimonial;
   
    if (this.dt && this.dt.filteredValue) {
      dadosParaExportar = this.dt.filteredValue;
    }

    this.authService.obterUsuarioPorId(this.userId).subscribe({
      next: (user) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Balanço Patrimonial');

        const tituloRow = worksheet.addRow(['Balanço Patrimonial']);
        tituloRow.font = { bold: true, underline: true };
        worksheet.mergeCells(`A${tituloRow.number}:G${tituloRow.number}`);
        tituloRow.alignment = { vertical: 'middle', horizontal: 'center' };

        const cnpjUsuarioTexto = user.cpfCnpj ? `${user.cpfCnpj}` : 'CNPJ não encontrado';
        const anoTexto = this.anoFormatado ? this.anoFormatado.getFullYear().toString() : 'Nenhum Ano Selecionado';

        const anoAnterior = anoTexto !== 'Nenhum Ano Selecionado' ? (parseInt(anoTexto) - 1).toString() : 'Nenhum Ano Selecionado';
        const cnpjRow = worksheet.addRow(['CNPJ:', cnpjUsuarioTexto]);
        const anoRow = worksheet.addRow(['Ano:', anoTexto]);

        [cnpjRow, anoRow].forEach(row => {
          row.getCell(1).font = { bold: true };
        });

        if (this.dt && this.dt.filteredValue && this.dt.filteredValue.length !== this.contasBalancoPatrimonial.length) {
          const filtroRow = worksheet.addRow(['Filtro de Pesquisa:', 'Aplicado']);
          filtroRow.getCell(1).font = { bold: true };
          const registrosRow = worksheet.addRow(['Registros Exportados:', `${dadosParaExportar.length} de ${this.contasBalancoPatrimonial.length}`]);
          registrosRow.getCell(1).font = { bold: true };
        }

        worksheet.addRow([]);

        const titleRow = worksheet.addRow([
          'Código',
          'Descrição',
          'Nível',
          anoTexto,
          'D/C',
          anoAnterior,
          'D/C'
        ]);

        titleRow.font = { bold: true };
        titleRow.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD3D3D3' },
        };

        worksheet.columns = [
          { key: 'codigo', width: 35 },
          { key: 'descricao', width: 40 },
          { key: 'nivel', width: 10 },
          { key: 'saldoAnoAtual', width: 15, style: { numFmt: 'R$ #,##0.00' } },
          { key: 'naturezaSaldoAnoAtual', width: 10 },
          { key: 'saldoAnoAnterior', width: 15, style: { numFmt: 'R$ #,##0.00' } },
          { key: 'naturezaSaldoAnoAnterior', width: 10 },
        ];

        dadosParaExportar.forEach((conta, index) => {
          const row = worksheet.addRow({
            codigo: conta.codigo,
            descricao: conta.descricao,
            nivel: conta.nivel,
            saldoAnoAtual: Math.abs(Number(conta.saldoAnoAtual) || 0),
            naturezaSaldoAnoAtual: conta.saldoAnoAtual !== 0 ? (conta.naturezaSaldoAnoAtual === TipoTransacaoContabil.Debito ? 'D' : 'C') : '',
            saldoAnoAnterior: Math.abs(Number(conta.saldoAnoAnterior) || 0),
            naturezaSaldoAnoAnterior: conta.saldoAnoAnterior !== 0 ? (conta.naturezaSaldoAnoAnterior === TipoTransacaoContabil.Debito ? 'D' : 'C') : ''
          });

          row.getCell(4).numFmt = '#,##0.00'; 
          row.getCell(6).numFmt = '#,##0.00'; 
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          
          const dataHora = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
          a.download = `Relatório-Balanço-Patrimonial-${dataHora}.xlsx`;
          
          a.click();
          window.URL.revokeObjectURL(url);

          this.spinnerService.hide();
          this.toastService.setMensagemToast('Relatório BP gerado com sucesso!', SeveridadeToast.Success);
        }).catch((error) => {
          console.error('Erro ao gerar Excel:', error);
          this.spinnerService.hide();
          this.toastService.setMensagemToast('Erro ao gerar relatório BP.', SeveridadeToast.Error);
        });
      },
      error: (err) => {
        this.spinnerService.hide();
        this.toastService.setMensagemToast('Erro Interno.', SeveridadeToast.Error);
      }
    });
  }

  voltar(): void {
    this.location.back();
  }
}
